// import { useRegisterSW } from 'virtual:pwa-register/react';
// import { useEffect } from 'react';

export function PWAUpdatePrompt() {
  // Temporarily disabled PWA registration for debugging
  // const {
  //   needRefresh: [needRefresh, setNeedRefresh],
  //   updateServiceWorker,
  // } = useRegisterSW({
  //   onRegistered(r) {
  //     console.log('SW Registered:', r);
  //   },
  //   onRegisterError(error) {
  //     console.log('SW registration error', error);
  //   },
  // });

  // useEffect(() => {
  //   if (needRefresh) {
  //     const shouldUpdate = window.confirm(
  //       'New content available! Click OK to refresh and get the latest updates.'
  //     );
  //     if (shouldUpdate) {
  //       updateServiceWorker(true);
  //     } else {
  //       setNeedRefresh(false);
  //     }
  //   }
  // }, [needRefresh, setNeedRefresh, updateServiceWorker]);

  return null;
}